"use client";
import { motion } from "framer-motion";

interface PostCardSkeletonProps {
    index?: number;
}

export default function PostCardSkeleton({ index = 0 }: PostCardSkeletonProps) {
    return (
        <motion.article
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
                delay: index * 0.1,
                duration: 0.3,
            }}
            className="h-full min-h-[380px] bg-white font-sans rounded-xl overflow-hidden shadow-post-card border border-neutral-200/80 flex flex-col"
        >
            <div className="flex flex-col flex-1 min-h-0">
                {/* Image skeleton */}
                <div className="relative w-full flex-shrink-0 overflow-hidden aspect-[900/464] bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse">
                    {/* Date badge skeleton */}
                    <div className="absolute top-5 left-5 w-[50px] h-[40px] bg-gray-400 rounded-sm animate-pulse" />
                </div>
                
                <div className="flex flex-col flex-1 min-h-0">
                    {/* Metadata skeleton */}
                    <div className="flex items-center justify-start gap-10 text-sm mt-4 mb-3 px-3">
                        <div className="flex items-center gap-3">
                            <div className="w-3 h-3 bg-gray-300 rounded animate-pulse" />
                            <div className="h-4 w-24 bg-gray-300 rounded animate-pulse" />
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-3 h-3 bg-gray-300 rounded animate-pulse" />
                            <div className="h-4 w-16 bg-gray-300 rounded animate-pulse" />
                        </div>
                    </div>
                    
                    <div className="px-3 pb-4 flex flex-col flex-1 min-h-0">
                        {/* Title skeleton */}
                        <div className="h-6 bg-gray-300 rounded mb-3 animate-pulse" style={{ width: '85%' }} />
                        <div className="h-6 bg-gray-300 rounded mb-3 animate-pulse" style={{ width: '70%' }} />
                        
                        {/* Description skeleton */}
                        <div className="space-y-2 mb-4">
                            <div className="h-4 bg-gray-200 rounded animate-pulse" style={{ width: '100%' }} />
                            <div className="h-4 bg-gray-200 rounded animate-pulse" style={{ width: '95%' }} />
                            <div className="h-4 bg-gray-200 rounded animate-pulse" style={{ width: '90%' }} />
                        </div>
                        
                        {/* Read more skeleton */}
                        <div className="flex items-center gap-2 mt-auto pt-6">
                            <div className="h-4 w-24 bg-gray-300 rounded animate-pulse" />
                            <div className="h-4 w-32 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                </div>
            </div>
        </motion.article>
    );
}

